import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import Logo from "@/components/Logo";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
      window.location.reload();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-charcoal px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-lg bg-ivory p-8 sm:p-10" data-testid="admin-login-form">
        <div className="flex justify-center"><Logo size="h-20" /></div>
        <h1 className="mt-8 text-center font-serif text-3xl text-charcoal">Owner Login</h1>
        <p className="mt-2 text-center text-xs text-charcoal/50">Heritage Constructions — admin dashboard</p>

        <div className="mt-8 space-y-5">
          <div>
            <label className="field-label" htmlFor="admin-email">Email</label>
            <input id="admin-email" type="email" className="field" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@heritageconstructions.com.au" data-testid="admin-email-input" />
          </div>
          <div>
            <label className="field-label" htmlFor="admin-password">Password</label>
            <input id="admin-password" type="password" className="field" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="admin-password-input" />
          </div>
          <button type="submit" disabled={busy} className="btn-dark w-full disabled:opacity-60" data-testid="admin-login-submit">
            {busy ? <><Loader2 size={15} className="animate-spin" /> Signing in…</> : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
}
